import Raven from 'raven-js';
import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
export default createTracker({
  events,
  onError: err => Raven.captureException(err)
});